import React from "react";

function ViewSize({ data }) {
  return (
    <div className="main_page">
      <div className="row g-3">
        {/* Size Name */}
        <div className="col-md-6">
          <label className="fw-semibold">Size Name</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.size_name || ""}
            readOnly
          />
        </div>

        {/* Size Code */}
        <div className="col-md-6">
          <label className="fw-semibold">Size Code</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.size_code || ""}
            readOnly
          />
        </div>

        {/* Category */}
        <div className="col-md-6">
          <label className="fw-semibold">Category</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.category_details?.name || "-"}
            readOnly
          />
        </div>

        {/* Sub Category */}
        <div className="col-md-6">
          <label className="fw-semibold">Sub Category</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.subcategory_details?.name || "-"}
            readOnly
          />
        </div>

        {/* Category Type */}
        <div className="col-md-6">
          <label className="fw-semibold">Category Type</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.category_type || "-"}
            readOnly
          />
        </div>

        {/* Sort Order */}
        <div className="col-md-6">
          <label className="fw-semibold">Sort Order</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.sort_order ?? "-"}
            readOnly
          />
        </div>

        {/* Status */}
        <div className="col-md-6">
          <label className="fw-semibold">Status</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.is_active === 1 ? "Active" : "Inactive"}
            readOnly
          />
        </div>

        {/* Description */}
        <div className="col-md-12">
          <label className="fw-semibold">Description</label>
          <textarea
            rows={4}
            className="form-control custumform"
            value={data?.description || ""}
            readOnly
          />
        </div>
      </div>
    </div>
  );
}

export default ViewSize;